import './activities/activity-data-collect-edit.js' /* refered by the activity template (activity-data-collect) on server */
import './activities/activity-data-collect-view.js' /* refered by the activity template (activity-data-collect) on server */
import './activities/activity-data-review-edit.js' /* refered by the activity template (activity-data-review) on server */
import './activities/activity-data-review-view.js' /* refered by the activity template (activity-data-review) on server */
import './activities/activity-ooc-review-edit.js' /* refered by the activity template (activity-ooc-review) on server */
import './activities/activity-ooc-review-view.js' /* refered by the activity template (activity-ooc-review) on server */
import './activities/activity-ooc-resolve-edit.js' /* refered by the activity template (activity-ooc-resolve) on server */
import './activities/activity-ooc-resolve-view.js' /* refered by the activity template (activity-ooc-resolve) on server */
import '@operato/app/filter-renderer.js' /* register resource-object filter renderer */

import { OxGristEditorCode } from '@operato/app/grist-editor/ox-grist-editor-code.js'
import {
  OxGristRendererJson5,
  registerEditor as registerGristEditor,
  registerRenderer as registerGristRenderer
} from '@operato/data-grist'
import { OxGristEditorDataItemSpec } from '@operato/dataset/grist-editor/ox-grist-editor-data-item-spec.js'
import { OxGristEditorPartitionKeys } from '@operato/grist-editor/ox-grist-editor-partition-keys.js'
import { OxGristRendererPartitionKeys } from '@operato/grist-editor/ox-grist-renderer-partition-keys.js'

import { OxGristEditorSignature } from '@operato/grist-editor/ox-grist-editor-signature.js'
import { OxGristRendererSignature } from '@operato/grist-editor/ox-grist-renderer-signature.js'

export default function bootstrap() {
  registerGristEditor('data-item-spec', OxGristEditorDataItemSpec)
  registerGristRenderer('data-item-spec', OxGristRendererJson5)

  registerGristEditor('script', OxGristEditorCode)

  registerGristEditor('partition-keys', OxGristEditorPartitionKeys)
  registerGristRenderer('partition-keys', OxGristRendererPartitionKeys)

  registerGristRenderer('signature', OxGristRendererSignature)
  registerGristEditor('signature', OxGristEditorSignature)
}
